import request from '@/utils/request'


// 查询科普分类列表
export function listPopularizeCategory(query) {
  return request({
    url: '/popularize/popularize/category/list',
    method: 'get',
    params: query
  })
}
export function listPopularizeCategory1(query) {
  return request({
    url: '/popularize/popularize/category/list1',
    method: 'get',
    params: query
  })
}
export function listAllPopularizeCategory(query) {
  return request({
    url: '/popularize/popularize/category/listAll',
    method: 'get',
    params: query
  })
}
// 查询科普分类分页
export function pagePopularizeCategory(query) {
  return request({
    url: '/popularize/popularize/category/page',
    method: 'get',
    params: query
  })
}

// 查询科普分类详细
export function getPopularizeCategory(data) {
  return request({
    url: '/popularize/popularize/category/detail',
    method: 'get',
    params: data
  })
}

// 新增科普分类
export function addPopularizeCategory(data) {
  return request({
    url: '/popularize/popularize/category/add',
    method: 'post',
    data: data
  })
}

// 修改科普分类
export function updatePopularizeCategory(data) {
  return request({
    url: '/popularize/popularize/category/edit',
    method: 'post',
    data: data
  })
}

// 删除科普分类
export function delPopularizeCategory(data) {
  return request({
    url: '/popularize/popularize/category/delete',
    method: 'post',
    data: data
  })
}
